import {useMutation, useQueryClient} from 'react-query';
import PatchFertilizerAdvertisement from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

interface IPostFertilizerAdvertisementProps {
  guid?: string;
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
}

const usePatchFertilizerAdvertisement = ({
  guid,
  onSuccess,
}: IPostFertilizerAdvertisementProps) => {
  const queryClient = useQueryClient();

  const data = useMutation({
    mutationFn: (payload: IFertilizerAdvertisementPayload) => {
      return PatchFertilizerAdvertisement(payload, guid);
    },
    onSuccess: data => {
      if (onSuccess) {
        onSuccess(data); // Passing the response to onSuccess
      }

      queryClient.invalidateQueries({queryKey: ['my-ads']}); // Invalidate personal ads
      queryClient.invalidateQueries({queryKey: ['get-store-lab-views']}); // Invalidate store ads
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return data;
};

export {usePatchFertilizerAdvertisement};
